
























import Component from "vue-class-component";
import { content } from '@/constants/commonContent';
import {Base} from "@/base";

@Component({
  name: 'HeaderProfileComponent'
})
export default class HeaderProfileComponent extends Base {
  defaultProfile = content.defaultProfile;
  // Computed
  get profileAvatar() {
    if (this.getMemberAvatar) return this.getMemberAvatar;
    return this.defaultProfile.avatar;
  }
  get profileName() {
    if (this.getMember()) return this.getMember().name;
    return this.isReader ? 'Agent' : this.defaultProfile.name;
  }
};
